[].slice.call(document.querySelectorAll('.form-container')).forEach(function(form) {
	var scriptWaypoint = new Waypoint({
        element: form,
        handler: function(direction) {
        	var iframe = form.querySelector('iframe');

		    iframe.src = iframe.dataset.src;

            this.destroy();
        },
        offset: '100%'
    });
});